import {toJS} from 'mobx';
import {AbstractEntity, AbstractEntityData} from './AbstractEntity';
import {CatalogPageEntity} from './CatalogPageEntity';
import {CatalogCategoryEntity} from './CatalogCategoryEntity';
import {CatalogTocEntity} from './CatalogTocEntity';

export interface CatalogEntityData extends AbstractEntityData {
  pages: CatalogPageEntity[];
  categories: CatalogCategoryEntity[]
  toc: CatalogTocEntity[]
}

export class CatalogEntity extends AbstractEntity<CatalogEntityData> {
  get pages() {
    return this.data.pages;
  }

  get categories() {
    return this.data.categories;
  }

  get toc() {
    return this.data.toc;
  }

  get pagesOneSiteMode() {
    const ret: CatalogPageEntity[][] = [];

    this.pages.map(page => {
      ret.push([page]);
    });

    return ret;
  }

  get pagesMagazineMode() {
    const ret: CatalogPageEntity[][] = [];

    const pages = toJS(this.pages);

    ret.push(pages.slice(0, 1));

    let i = 1;
    const l = pages.length;

    while (i < l) {
      ret.push(pages.slice(i, i += 2));
    }

    return ret;
  }

  get firstPage() {
    return this.pages[0];
  }
}
